const UIDS = {
    dev: 'G-K8K8MZZCGB',
    qa: 'G-H7GLSQFW6J',
    cert: 'G-25G93EJK6S',
    prod: 'G-YLDXTHDZH7'
};

const detectEnvironment = (origin: string): keyof typeof UIDS => {
    if (
        origin.includes('localhost') ||
        origin.includes('127.0.0.1') ||
        origin.includes('.dv')
    ) {
        return 'dev';
    }
    if (origin.includes('uat') || origin.includes('.ut.')) {
        return 'cert';
    }
    if (origin.includes('qa') || origin.includes('.pt.')) {
        return 'qa';
    }
    return 'prod';
};

const environmentType = detectEnvironment(window.location.origin);

const {
    location: {hostname, port, protocol}
} = window;

export default Object.freeze({
    baseURL: `${protocol}//${hostname}${port && ':' + port}`,
    // @ts-ignore
    buildTime: window.BUILD_TIME || new Date().toUTCString(),
    cacheMaxAge: 1000 * 60 * 60 * 2,
    // @ts-ignore
    versionNumber: window.VERSION_NUMBER,
    devEnv: process.env.NODE_ENV === 'development',
    environmentType,
    environmentUID: UIDS[environmentType],
    testEnv: process.env.NODE_ENV === 'test',
    websocketNotifications: ['localhost', '127.0.0.1'].includes(hostname)
        ? `${(process.env.CDMMW_WS_ORIGIN || 'ws://localhost:9000').replace(/\/+$/, '')}/cdmmw/notifications`
        : `wss://${hostname}${port ? ':' + port : ''}/cdmmw/notifications`
});
